import styles from './Checkbox.module.scss';

export default function CheckboxComponent({checkboxId, checkboxValue, textLabel, isChecked, setIsChecked}) {

    return (
        <label htmlFor={checkboxId} className={styles.checkboxLabel}>
            <input
                type="checkbox"
                id={checkboxId}
                value={checkboxValue}
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
            />
            {textLabel}
        </label>
    );
}